<div class="wrapper">

  <!-- LEFT -->
  <div *ngIf="guestuser" class="loginformbox">
    <img [src]="'assets/loginbgimg.jpg'" alt="bg login img" class="bgimgc">
    <div class="loginbox">
      <!-- Logo -->
      <div class="logo">
        <img [src]="'assets/logo-dark.png'" alt="log">
      </div>

      <!-- Heading & Login Form -->
      <div *ngIf="!showForgotPassword && !isupdatepassword">
        <div class="welcome">
          <h2>Welcome to Taveelo Sign into your account</h2>
        </div>

        <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm.value)" novalidate>

          <input type="hidden" [(ngModel)]="User.CompanyId" name="CompanyId" />

          <!-- Username -->
          <div class="form-group">

            <input type="email" class="form-input" placeholder="Username" name="username" [(ngModel)]="User.Username"
              #username="ngModel" required minlength="4" />

            <div class="error-msg" *ngIf="username.invalid && (username.dirty || username.touched)">
              * Username is required (min 4 characters)
            </div>

          </div>

          <!-- Password -->
          <div class="form-group" style="position: relative;">

            <input [type]="showPassword ? 'text' : 'password'" class="form-input" placeholder="Password" name="password"
              [(ngModel)]="User.Password" #password="ngModel" required style="padding-right: 42px;" />

            <span class="eye-toggle" (click)="showPassword = !showPassword">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="#aab4c4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="#1a73e8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            </span>

            <div class="error-msg" *ngIf="password.invalid && (password.dirty || password.touched)">
              * Password is required
            </div>

          </div>

          <!-- Login Button -->
          <button type="submit" class="btn-login" [disabled]="!loginForm.valid || isloading">
            {{ isloading ? 'Logging in...' : 'Log In' }}
          </button>

          <div class="forgot-wrapper">
            <a (click)="toggleForgotPassword()" class="forgot" style="cursor: pointer;">
              Forgot password?
            </a>
          </div>

        </form>
      </div>

      <div *ngIf="showForgotPassword && !isupdatepassword">
        <div class="welcome">
          <h2>Reset Password</h2>
          <p>
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        <form #forgotForm="ngForm" (ngSubmit)="onForgotSubmit(forgotForm.value)" novalidate>

          <div class="form-group">
            <input type="email" class="form-input" placeholder="Email Address" name="forgotEmail"
              [(ngModel)]="forgotEmail" #email="ngModel" required email />

            <div class="error-msg" [class.show]="email.invalid && (email.dirty || email.touched)">
              * Valid email is required
            </div>
          </div>

          <button type="submit" class="btn-login" [disabled]="!forgotForm.valid">
            Send Reset Link
          </button>

          <div class="forgot-wrapper">
            <a (click)="toggleForgotPassword()" class="forgot" style="cursor: pointer;">
              Back to Login
            </a>
          </div>

        </form>
      </div>

      <div *ngIf="isupdatepassword">
        <div class="welcome">
          <h2>Update Password</h2>
          <p>
            Create a new password for your account.
          </p>
        </div>

        <form [formGroup]="updatePasswordForm" (ngSubmit)="onUpdatePasswordSubmit()" novalidate>

          <div class="form-group">
            <input type="password" class="form-input" placeholder="New Password" formControlName="password" />
            <div class="error-msg" [class.show]="updatePasswordForm.get('password')?.invalid && (updatePasswordForm.get('password')?.dirty || updatePasswordForm.get('password')?.touched)">
              * Password is required (min 6 characters)
            </div>
          </div>

          <div class="form-group">
            <input type="password" class="form-input" placeholder="Confirm Password" formControlName="confirmpassword" />
            <div class="error-msg" [class.show]="updatePasswordForm.get('confirmpassword')?.invalid && (updatePasswordForm.get('confirmpassword')?.dirty || updatePasswordForm.get('confirmpassword')?.touched)">
              * Confirm Password is required
            </div>
            <div class="error-msg" [class.show]="updatePasswordForm.hasError('passwordMismatch') && (updatePasswordForm.get('confirmpassword')?.dirty || updatePasswordForm.get('confirmpassword')?.touched)">
              * Passwords do not match
            </div>
          </div>

          <button type="submit" class="btn-login" [disabled]="updatePasswordForm.invalid">
            Update Password
          </button>

          <div class="forgot-wrapper">
            <a (click)="isupdatepassword = false" class="forgot" style="cursor: pointer;">
              Back to Login
            </a>
          </div>

        </form>
      </div>

    </div>

    <!--<div class="register-row">
    Don't have an account? <a href="/usersignup">Register</a>
  </div>-->
  </div>

</div>